"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderAvatarSvg = renderAvatarSvg;
exports.avatarDataUri = avatarDataUri;
const core_1 = require("@dicebear/core");
const avataaars = __importStar(require("@dicebear/avataaars"));
const items_1 = require("./items");
const options_1 = require("./options");
const layers_1 = require("./layers");
const SVG_SUFFIX = '</g></g></g></svg>';
const BACKGROUND_CIRCLE = /<circle cx="132" cy="160" r="120" fill="#[0-9a-fA-F]{6}"\/>/;
const CACHE_LIMIT = 500;
// The Avataaars group that holds the hair.
const HAIR_GROUP = '<g transform="translate(-1)">';
/** The Avataaars groups that hold the mouth, nose, eyes and eyebrows, by their fixed offsets. */
const FACE_GROUPS = ['translate(78 134)', 'translate(104 122)', 'translate(76 90)', 'translate(76 82)'];
const cache = new Map();
/** An id this build does not know (a newer option, a bad value) draws as the trait's first option. */
function known(trait, value) {
    const options = options_1.AVATAR_OPTIONS[trait];
    return typeof value === 'string' && options.includes(value) ? value : options[0];
}
function removeGroup(svg, transform) {
    const start = svg.indexOf(`<g transform="${transform}">`);
    if (start === -1)
        return svg;
    let depth = 0;
    const tags = /<g[\s>]|<\/g>/g;
    tags.lastIndex = start;
    for (let match = tags.exec(svg); match; match = tags.exec(svg)) {
        depth += match[0] === '</g>' ? -1 : 1;
        if (depth === 0)
            return svg.slice(0, start) + svg.slice(match.index + match[0].length);
    }
    return svg;
}
function backgroundMarkup(background, rotation, backLayers, visible) {
    const [from, to] = background.split('-');
    return `<defs><linearGradient id="dwfBg" gradientTransform="rotate(${rotation} .5 .5)">`
        + `<stop offset="0" stop-color="#${from}"/><stop offset="1" stop-color="#${to}"/></linearGradient>`
        + '<clipPath id="dwfBgClip"><circle cx="132" cy="160" r="120"/></clipPath>'
        + `<clipPath id="dwfUnderHat"><rect x="0" y="${layers_1.HAT_BRIM_Y}" width="280" height="280"/></clipPath></defs>`
        + (visible ? '<circle cx="132" cy="160" r="120" fill="url(#dwfBg)"/>' : '')
        + (backLayers ? `<g clip-path="url(#dwfBgClip)">${backLayers}</g>` : '');
}
/** The item an avatar wears in a trait, when the trait holds an item reference the list knows. */
function wornItem(value, slot, items) {
    const id = (0, items_1.itemIdOf)(value);
    const item = id ? items === null || items === void 0 ? void 0 : items.get(id) : undefined;
    return item && item.slot === slot ? item : null;
}
const layerMarkup = (item, position) => (item ? item.layers.filter(l => l.position === position).map(l => l.svg).join('') : '');
/**
 * Draws an avatar. `items` is the back-office item list: an avatar wearing an
 * item the list does not have (not downloaded yet, or deleted) is drawn
 * without it.
 */
function renderAvatarSvg(config, items, options = {}) {
    var _a;
    const headwearItem = wornItem(config.headwear, 'headwear', items);
    const propItem = wornItem(config.prop, 'accessory', items);
    const key = JSON.stringify(config)
        + (headwearItem ? `|${headwearItem.version}` : '') + (propItem ? `|${propItem.version}` : '')
        + (options.faceless ? ':faceless' : '') + (options.noBackground ? ':nobg' : '');
    const cached = cache.get(key);
    if (cached)
        return cached;
    // An item takes the place of the built-in choice for its trait.
    const headwear = (0, items_1.itemIdOf)(config.headwear) ? 'none' : known('headwear', config.headwear);
    const hair = (headwearItem === null || headwearItem === void 0 ? void 0 : headwearItem.hidesHair) ? 'none' : known('top', config.top);
    // A hijab or turban is a stock Avataaars top that replaces the hair; a hat or kippah is drawn over it.
    const baseTop = options_1.HAIR_COVERING_HEADWEAR.includes(headwear) ? headwear : hair;
    const glasses = known('glasses', config.glasses);
    const prop = (0, items_1.itemIdOf)(config.prop) ? 'none' : known('prop', config.prop);
    const facialHair = known('facialHair', config.facialHair);
    const clothing = known('clothing', config.clothing);
    const clothesColor = known('clothesColor', config.clothesColor);
    const hairColor = known('hairColor', config.hairColor);
    const hatColor = known('hatColor', config.hatColor);
    const background = known('background', config.background);
    const rotation = Number.isFinite(config.backgroundRotation) ? config.backgroundRotation : 0;
    const dicebearOptions = {
        seed: 'dwf',
        style: ['circle'],
        backgroundColor: [background.split('-')[0]],
        skinColor: [known('skin', config.skin)],
        top: baseTop === 'none' ? undefined : [baseTop],
        topProbability: baseTop === 'none' ? 0 : 100,
        hairColor: [hairColor],
        hatColor: [hatColor],
        eyes: [known('eyes', config.eyes)],
        eyebrows: [known('eyebrows', config.eyebrows)],
        mouth: [known('mouth', config.mouth)],
        facialHair: facialHair === 'none' ? undefined : [facialHair],
        facialHairProbability: facialHair === 'none' ? 0 : 100,
        facialHairColor: [hairColor],
        accessories: glasses === 'none' ? undefined : [glasses],
        accessoriesProbability: glasses === 'none' ? 0 : 100,
        accessoriesColor: [known('glassesColor', config.glassesColor)],
        clothing: [(_a = options_1.CUSTOM_CLOTHING_BASE[clothing]) !== null && _a !== void 0 ? _a : clothing],
        clothesColor: [clothesColor],
    };
    let svg = (0, core_1.createAvatar)(avataaars, dicebearOptions).toString();
    if (options.faceless)
        svg = FACE_GROUPS.reduce(removeGroup, svg);
    if (headwear === 'hat')
        svg = svg.replace(HAIR_GROUP, '<g clip-path="url(#dwfUnderHat)" transform="translate(-1)">');
    const back = layerMarkup(headwearItem, 'back') + layerMarkup(propItem, 'back');
    svg = svg.replace(BACKGROUND_CIRCLE, backgroundMarkup(background, rotation, back, !options.noBackground));
    if (svg.endsWith(SVG_SUFFIX)) {
        svg = svg.slice(0, -SVG_SUFFIX.length)
            + (0, layers_1.headwearLayer)(headwear, hatColor, hair === 'none')
            + layerMarkup(headwearItem, 'front')
            + (0, layers_1.clothingLayer)(clothing, clothesColor, known('accentColor', config.accentColor))
            + (0, layers_1.propLayer)(prop, {
                propColor: known('propColor', config.propColor),
                variant: options_1.AVATAR_OPTIONS.background.indexOf(background),
                overTurtleneck: clothing === 'turtleneck',
            })
            + layerMarkup(propItem, 'front')
            + SVG_SUFFIX;
    }
    if (cache.size >= CACHE_LIMIT)
        cache.delete(cache.keys().next().value);
    cache.set(key, svg);
    return svg;
}
function avatarDataUri(config, items, options) {
    return `data:image/svg+xml;utf8,${encodeURIComponent(renderAvatarSvg(config, items, options))}`;
}
